import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderApiProps {
  providerData: {};
}

const ProviderApiSlice = createSlice({
  name: 'SET_PROVIDER_API',
  initialState:{providerData:{}},
  reducers: {
    setProviderApi: (state, action: PayloadAction<ProviderApiProps>) => {
      state.providerData = action.payload;
    },
  },
});

const { reducer, actions } = ProviderApiSlice;

// Actions
export const { setProviderApi } = actions;

export const SearchProviderApiReducer = reducer;
